/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedFavoritesProvider_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"FolderWrapperWrapper_viewer" | "HeartWrapper_viewer" | "PortfolioFolderWrapper_viewer">;
    readonly " $refType": "SharedFavoritesProvider_viewer";
};
export type SharedFavoritesProvider_viewer$data = SharedFavoritesProvider_viewer;
export type SharedFavoritesProvider_viewer$key = {
    readonly " $data"?: SharedFavoritesProvider_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedFavoritesProvider_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "selectedItemIds",
  "variableName": "selectedItemIds"
},
v1 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v2 = [
  (v0/*: any*/),
  {
    "kind": "Variable",
    "name": "shouldFillInFolder",
    "variableName": "shouldFillInFolder"
  },
  (v1/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "SharedFavoritesProvider_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "selectedItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "loadPortfolioData",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "shouldFillInFolder",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FolderWrapperWrapper_viewer",
      "args": (v2/*: any*/)
    },
    {
      "kind": "FragmentSpread",
      "name": "HeartWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "loadPortfolioData"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PortfolioFolderWrapper_viewer",
      "args": (v2/*: any*/)
    }
  ]
};
})();
(node as any).hash = 'f3d7c56a2f194d3108b8366801428449';
export default node;
